/* Phần dùng chung giữa Products, Concepts và Reflections. */
import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { Icon } from "@/components/icon"

export const learningTypeLabel: Record<string, string> = {
  architecture: "Kiến trúc", checklist: "Checklist", concept: "Key Concept", formula: "Công thức",
  framework: "Framework", mental_model: "Mental Model", method: "Phương pháp", metric: "Metric",
  pattern: "Pattern", principle: "Nguyên tắc", protocol: "Protocol", standard: "Tiêu chuẩn",
  taxonomy: "Taxonomy", theory: "Lý thuyết", tool: "Công cụ",
}

/** Nút thoát chế độ tập trung, quay về danh sách (mặc định: Products). */
export function LearningModeExit({ slug, to }: { slug: string; to?: string }) {
  return (
    <Button variant="outline" size="sm" nativeButton={false} render={<Link to={to ?? `/classes/${slug}/products`} />}>
      <Icon name="arrow-left" className="size-4" /> Thoát bài học
    </Button>
  )
}
